var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnemia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7024 10.772C13.5965 7.17016 18.5133 4.2949 19.3504 0.0449219C20.1874 4.2949 25.1042 7.17016 24.9984 10.772C24.9984 16.6743 13.7024 16.6743 13.7024 10.772Z",
    fill: "#FF7069"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3501 0.0449219C20.1871 4.2949 25.1037 7.17016 24.9981 10.7718C24.9981 15.3183 18.2967 16.3618 15.2173 13.9043C17.7718 15.4962 22.3877 14.8799 23.8315 12.4419C26.0804 8.64473 19.3397 4.50431 19.3501 0.0449219Z",
    fill: "#F7635B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6191 4.71387C17.6191 4.71387 12.9657 9.07757 14.5816 11.6322C15.933 13.7686 15.754 7.61052 17.6191 4.71387Z",
    fill: "#FF878E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00263489 18.0109C-0.163201 12.361 7.54952 7.85058 8.86249 1.18408C10.1755 7.85058 17.8882 12.361 17.7223 18.0109C17.7223 27.2695 0.00263489 27.2695 0.00263489 18.0109Z",
    fill: "#FF7069"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86243 1.18408C10.1756 7.85058 17.8881 12.361 17.7223 18.0109C17.7223 25.1424 7.21018 26.7793 2.37988 22.9243C6.38674 25.4215 13.6274 24.4549 15.8926 20.6303C19.42 14.6741 8.84634 8.17906 8.86243 1.18408Z",
    fill: "#F7635B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14674 8.50732C6.14674 8.50732 -1.15251 15.3523 1.38253 19.3596C3.50222 22.7107 3.2213 13.0511 6.14674 8.50732Z",
    fill: "#FF908A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnemia);
export default __webpack_public_path__ + "static/media/anemia.93fd164a2d86022c9ba2c5bb093c39c2.svg";
export { ForwardRef as ReactComponent };